import React, { useEffect, useState } from 'react';
import useGetPatientSurveyList from './hooks/useGetPatientSurveyList';
import {
  Alert,
  Container,
  LinearProgress,
  Stack,
} from '@mui/material';
import SurveyList from './components/SurveyList';
import Survey from './components/Survey';
import { sortLatestDate } from './functions/sortLatestDate';
import DateRangePicker from 'Global/Components/CommonComponents/DateRangePicker/DateRangePicker';
import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import i18next from 'i18next';
import { useAtom } from 'jotai';

const PatientSurveyList = () => {
  const userFilterChoice = JSON.parse(
    sessionStorage.getItem('userFilterChoice')
  );

  const [formFilter, setFormFilter] = useState(
    () =>
      JSON.parse(
        sessionStorage.getItem('userFilterChoice')
      ) || 0
  );

  const data = useGetPatientSurveyList(formFilter);

  const formType_label = FindLangKey(
    'patient-survey-list-filter-name-survey-type'
  );
  const filledForm_label = FindLangKey(
    'patient-survey-list-filter-list-filled-form-selection'
  );
  const UnfilledForm_label = FindLangKey(
    'patient-survey-list-filter-list-not-filled-form-selection'
  );

  const allItems_label = FindLangKey(
    'genral-public-label-all'
  );
  const notFoundMsg = FindLangKey(
    'general-public-flat-alert-no-data'
  );

  const selectableDataArray = [
    { ItemContent: allItems_label, ItemValue: 2 },
    { ItemContent: UnfilledForm_label, ItemValue: 0 },
    { ItemContent: filledForm_label, ItemValue: 1 },
  ];

  // useEffect(() => {
  //   setSharedSurvey(data);
  // }, [data]);

  console.log('datadata--->', data);

  return (
    <React.Fragment>
      <div
        style={{
          padding: '1em',
          paddingBottom: 0,
        }}
      >
        <EditableCustomizableSelect
          label={formType_label}
          enableInitialOnchange={true}
          initialData={[
            {
              ItemContent: userFilterChoice
                ? selectableDataArray?.filter(
                    (el) =>
                      el.ItemValue === userFilterChoice
                  )[0]?.ItemContent
                : UnfilledForm_label,
              ItemValue: userFilterChoice
                ? selectableDataArray?.filter(
                    (el) =>
                      el.ItemValue === userFilterChoice
                  )[0]?.ItemContent
                : UnfilledForm_label,
            },
          ]}
          SelectableDataArray={selectableDataArray}
          isSingle={true}
          isEnglish={i18next.language === 'en'}
          onChange={(val) => {
            setFormFilter(val);
            sessionStorage.setItem(
              'userFilterChoice',
              JSON.stringify(val)
            );
          }}
        />
      </div>
      {data === 'loading' ? (
        <div
          style={{
            padding: '1em',
          }}
        >
          <LinearProgress />
        </div>
      ) : data?.length === 0 ? (
        <Container sx={{ mt: '1em' }}>
          <Alert
            dir={i18next.language === 'en' ? 'ltr' : 'rtl'}
            severity="info"
          >
            {notFoundMsg}
          </Alert>
        </Container>
      ) : (
        <Stack>
          <div
            style={{
              padding: '.5em',
            }}
          >
            {/* <DateRangePicker /> */}
          </div>
          <SurveyList>
            {sortLatestDate(data)?.map((survey,index) => (
              <Survey key={survey?.Id} survey={survey} index={index}/>
            ))}
          </SurveyList>
        </Stack>
      )}
    </React.Fragment>
  );
};

export default PatientSurveyList;
